import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(1),
};
